import { createAction } from "@reduxjs/toolkit";

export const fetchOfficeData = createAction("common/officeData");
export const fetchPopularArticles = createAction("common/popularArticles");
